import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useFieldglassCompanyGroupsQuery } from 'queries/admin/fieldglass/useFieldglassCompanyGroupsQuery'
import { FieldglassCompanyGroup } from 'api/admin/fieldglass/listFieldglassCompanyGroups'

type FieldglassReferenceDataContextState = {
  state: {
    companyGroups: FieldglassCompanyGroup[]
    isPending: boolean
    isError: boolean
    error: string
    dataUpdatedAt: number
    isFetching: boolean
  }
  actions: {
    refetch: () => void
  }
}

const [Context, useFieldglassReferenceDataContextValue] =
  createContext<FieldglassReferenceDataContextState>({
    name: 'FieldglassReferenceDataContext',
  })

export const FieldglassReferenceDataProvider = ({
  children,
}: PropsWithChildren) => {
  const companyGroupsQuery = useFieldglassCompanyGroupsQuery()

  const value: FieldglassReferenceDataContextState = {
    state: {
      companyGroups: companyGroupsQuery.data?.items ?? [],
      isPending: companyGroupsQuery.isPending,
      isError: companyGroupsQuery.isError,
      error: parseErrorMessage(companyGroupsQuery.error),
      dataUpdatedAt: companyGroupsQuery.dataUpdatedAt,
      isFetching: companyGroupsQuery.isFetching,
    },
    actions: {
      refetch: () => {
        void companyGroupsQuery.refetch()
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useFieldglassReferenceDataContextValue }
